module.exports = __webpack_public_path__ + "img/csfs-logo-new.05eee6f3.svg";